import Vue from 'vue'

Vue.directive('blur-on-leave', {
	bind (el) {
		// fix the "sticky hover" problem on mobile devices, but also disable :activate pseudo-class
		el.addEventListener('touchstart', (e) => {
			e.preventDefault();
			el.dispatchEvent(new MouseEvent('click'));
		});
		// fix the "sticky focus" problem
		el.addEventListener('mouseup', (e) => {
			el.blur();
		});
	}
});